/* ==========================================================================
   CLARITY HEALTH CO — COMPARISON  (Phase 6)
   Below 1024px only one competitor column shows; the next button cycles it
   through the rest. Honours prefers-reduced-motion.

   NOTE (perf): the photograph is intentionally STATIC. An earlier build drove a
   gentle parallax from a requestAnimationFrame loop, but moving the image behind
   the frosted glass forced the backdrop to re-rasterise every scroll frame and
   caused jank through this section. The scroll-linked loop was removed; the
   image now composites once and scrolls with the page for free.
   ========================================================================== */
(function () {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.clarity-cmp').forEach((sec) => {
    /* ----- competitor cycling (mobile) — click-driven, not scroll-linked ----- */
    const dataEl = sec.querySelector('[data-cmp-data]');
    let brands = [];
    try { brands = JSON.parse(dataEl.textContent); } catch (e) { brands = []; }
    const nextBtn = sec.querySelector('[data-cmp-next]');
    const cells = Array.from(sec.querySelectorAll('.clarity-cmp__cell [data-cmp]'));
    let idx = 0;

    if (nextBtn && brands.length > 1) {
      nextBtn.addEventListener('click', () => {
        idx = (idx + 1) % brands.length;
        const b = brands[idx];
        const apply = () => cells.forEach((el) => { el.textContent = b[el.dataset.cmp] != null ? b[el.dataset.cmp] : ''; });
        if (reduce) { apply(); return; }
        cells.forEach((el) => { el.style.opacity = '0'; });
        setTimeout(() => { apply(); cells.forEach((el) => { el.style.opacity = '1'; }); }, 180);
      });
    } else if (nextBtn) {
      nextBtn.hidden = true;
    }
  });
})();
